import { render, staticRenderFns } from "./productAttrList.vue?vue&type=template&id=aacce05e&scoped=true&"
import script from "./productAttrList.vue?vue&type=script&lang=js&"
export * from "./productAttrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacce05e",
  null
  
)

export default component.exports